import React from 'react';
import { FiClock, FiStar } from 'react-icons/fi';
import TrialExpiredMessage from './TrialExpiredMessage';

const TrialStatus = ({ trialStatus, onUpgradeClick }) => {
  const { isTrialUser, daysRemaining, isTrialExpired, isPaidUser, canUseChat } = trialStatus;

  // Don't show anything if we don't have valid status
  if (!isTrialUser && !isPaidUser) {
    return null;
  }

  // Paid user - show premium status
  if (isPaidUser) {
    return (
      <div className="mx-2 mb-2 p-3 bg-gradient-to-r from-yellow-100 to-amber-100 border border-yellow-300 rounded-lg">
        <div className="flex items-center gap-2 text-amber-700">
          <FiStar className="text-amber-500" size={16} />
          <span className="text-sm font-semibold">Premium Member</span>
        </div>
        <p className="text-xs text-amber-600 mt-1">Unlimited access to Bela</p>
      </div>
    );
  }

  // Trial user - expired
  if (isTrialExpired) {
    return (
      <div className="mx-2 mb-2">
        <TrialExpiredMessage 
          onUpgradeClick={onUpgradeClick}
          variant="compact"
          trialDurationDays={trialStatus.trialDurationDays}
        />
      </div>
    );
  }

  // Trial user - active trial
  const getTrialColor = () => {
    if (daysRemaining <= 1) return 'from-red-100 to-rose-100 border-red-300';
    if (daysRemaining <= 3) return 'from-orange-100 to-yellow-100 border-orange-300';
    return 'from-blue-100 to-indigo-100 border-blue-300';
  };

  const getTextColor = () => {
    if (daysRemaining <= 1) return 'text-red-700';
    if (daysRemaining <= 3) return 'text-orange-700';
    return 'text-blue-700';
  };

  const getIconColor = () => {
    if (daysRemaining <= 1) return 'text-red-500';
    if (daysRemaining <= 3) return 'text-orange-500';
    return 'text-blue-500';
  };

  return (
    <div className={`mx-2 mb-2 p-3 bg-gradient-to-r ${getTrialColor()} border rounded-lg`}>
      <div className={`flex items-center gap-2 ${getTextColor()} mb-2`}>
        <FiClock className={getIconColor()} size={16} />
        <span className="text-sm font-semibold">Free Trial</span>
      </div>
      <p className={`text-xs ${getTextColor()} mb-3`}>
        {daysRemaining === 1 
          ? 'Last day of your free trial!' 
          : `${daysRemaining} days remaining`}
      </p>
      <button
        onClick={onUpgradeClick}
        className={`w-full text-xs font-semibold py-2 px-3 rounded transition-all duration-200 shadow-sm ${
          daysRemaining <= 1 
            ? 'bg-gradient-to-r from-red-500 to-rose-500 hover:from-red-600 hover:to-rose-600 text-white'
            : daysRemaining <= 3
            ? 'bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white'
            : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white'
        }`}
      >
        Upgrade to Premium
      </button>
    </div>
  );
};

export default TrialStatus;
